
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SectionExerciseFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SectionExercise"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"duration"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"notes"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"detailedMetrics"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distance"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"min"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"max"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"single"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"repetitions"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"min"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"max"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"single"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"weight"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"min"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"max"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"single"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"calories"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"min"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"max"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"single"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"rpe"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"exercise"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExerciseFragment"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"alternativeExercises"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExerciseFragment"},"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"weight"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"repetitions"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"distance"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":543}};
    doc.loc.source = {"body":"#import 'app/graphql/fragments/exercise.gql'\n\nfragment SectionExerciseFragment on SectionExercise {\n  id\n  description\n  duration\n  notes\n  detailedMetrics {\n    distance {\n      min\n      max\n      single\n    }\n    repetitions {\n      min\n      max\n      single\n    }\n    weight {\n      min\n      max\n      single\n    }\n    calories {\n      min\n      max\n      single\n    }\n  }\n  rpe\n  exercise {\n    ...ExerciseFragment\n    alternativeExercises {\n      ...ExerciseFragment\n    }\n  }\n  # Deprecated fields\n  weight\n  repetitions\n  distance\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require('app/graphql/fragments/exercise.gql').definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["SectionExerciseFragment"] = oneQuery(doc, "SectionExerciseFragment");
        
